const Telegram = () => (
    <svg
        width='31'
        height='26'
        viewBox='0 0 31 26'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M28.2016 0.329309C28.2016 0.329309 31.0346 -0.775378 30.7985 1.90744C30.7198 3.01214 30.0116 6.87854 29.4607 11.0606L27.572 23.4489C27.572 23.4489 27.4147 25.2638 25.9981 25.5794C24.5816 25.895 22.4568 24.4747 22.0633 24.1591C21.7485 23.9224 16.1612 20.3716 14.1938 18.6356C13.6429 18.1622 13.0133 17.2153 14.2724 16.1106L22.5355 8.21999C23.4799 7.2731 24.4242 5.06372 20.4894 7.74654L9.47205 15.2427C9.47205 15.2427 8.21293 16.0317 5.85211 15.3216L0.736869 13.7434C0.736869 13.7434 -1.15183 12.5598 2.07469 11.3762C9.94426 7.66758 19.6238 3.88007 28.2016 0.329309Z'
            fill='white'
        />
    </svg>
);

export default Telegram;
